import { useQuery } from '@tanstack/react-query';

import { getSyncConflicts } from '@/api/sync/get-sync-conflicts';
import { POLL_IDLE_MS } from '@/constants/sync';

import { syncKeys } from './query-keys';

/** `enabled` is false for someone who may not read it, so the request the gateway would refuse is never made. */
export const useSyncConflicts = (enabled = true) =>
  useQuery({
    queryKey: syncKeys.conflicts(),
    queryFn: getSyncConflicts,
    enabled,
    refetchInterval: POLL_IDLE_MS,
  });
